import React from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const BlogDetailPage = () => {
  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      <section className="py-5 consultancy-section-dark">
        <div className="container" style={{ maxWidth: "850px" }}>
          <span className="badge bg-warning text-dark font-weight-bold px-3 py-1 rounded-pill mb-3">Visa Updates</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">
            UK Post-Study Work Visa 2026: Complete Policy Update & Rules
          </h1>
          <div className="d-flex align-items-center gap-3 text-muted small mb-4">
            <span><i className="fas fa-user-edit text-warning mr-1"></i> By EdOps Visa Advisory Desk</span>
            <span>&bull;</span>
            <span><i className="fas fa-calendar-alt text-warning mr-1"></i> August 8, 2026</span>
            <span>&bull;</span>
            <span><i className="fas fa-clock text-warning mr-1"></i> 5 Min Read</span>
          </div>

          <img
            src="https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=1000&q=80"
            alt="UK Post Study Work Visa"
            className="img-fluid rounded-4 mb-5 shadow-lg"
            style={{ border: "1px solid rgba(212, 175, 55, 0.25)" }}
          />

          <div className="consultancy-glass-card p-4 p-md-5">
            <h3 className="consultancy-gold-title font-weight-bold mb-3">1. Executive Summary</h3>
            <p className="text-muted" style={{ lineHeight: "1.8" }}>
              The UK Graduate Route Visa remains one of the most attractive post-study work pathways for international students. Successful graduates of UK Bachelor's or Master's degrees are granted a 2-year unsponsored work permit (3 years for PhD graduates), allowing them to work in any sector.
            </p>

            <h3 className="consultancy-gold-title font-weight-bold mt-4 mb-3">2. Eligibility Criteria</h3>
            <ul className="text-muted list-unstyled d-flex flex-column gap-2">
              <li><i className="fas fa-check-circle text-warning mr-2"></i> Must have successfully completed an eligible UK higher education course.</li>
              <li><i className="fas fa-check-circle text-warning mr-2"></i> Must hold a valid Student Visa (formerly Tier 4) at the time of application inside the UK.</li>
              <li><i className="fas fa-check-circle text-warning mr-2"></i> University must formally notify the UK Home Office of your course completion.</li>
            </ul>

            <h3 className="consultancy-gold-title font-weight-bold mt-4 mb-3">3. Transitioning to Skilled Worker Sponsorship</h3>
            <p className="text-muted" style={{ lineHeight: "1.8" }}>
              During your 2-year Graduate Route visa, you can gain valuable UK work experience. Once you secure a role with a licensed UK sponsor meeting the salary threshold, you can switch seamlessly to a 5-year Skilled Worker Visa, paving the way for Permanent Residency (ILR).
            </p>

            <div className="consultancy-pill-card p-4 my-4 text-center">
              <h5 className="consultancy-gold-title font-weight-bold mb-2">Need Assistance With Your UK Visa Application?</h5>
              <p className="text-muted small mb-3">Talk to our certified UK immigration counselors for CAS guidance and financial proofing.</p>
              <Link to="/consultancy/book-consultation" className="consultancy-btn-gold px-4 py-2">
                Book UK Visa Counselling <i className="fas fa-passport ml-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default BlogDetailPage;
